/*const SAMPLE_FILTER = [
  {
    filterItem: "fin_region",
    id: "ETF_CORPORATE_BONDS_DYNAMIC_REGION",
    values: [
      {
        id: "WORLD",
        name: "Welt",
        orderNumber: 1,
      },
      {
        id: "DEVELOPED_MARKETS",
        name: "Industrieländer (weltweit)",
        orderNumber: 2,
      },
    ],
  },
  {
    filterItem: "fin_strategy",
    id: "ETF_CORPORATE_BONDS_DYNAMIC_RATING",
    values: [
      {
        id: "73",
        name: "Investment Grade",
        orderNumber: 1,
      },
    ],
  },
  {
    filterItem: "duration",
    id: "ETF_CORPORATE_BONDS_DYNAMIC_TERM",
    values: [
      {
        id: "107",
        name: "Alle Laufzeiten",
        orderNumber: 1,
      },
    ],
  },
]*/

//buildEtfFilter(SAMPLE_FILTER, 'ETF_CORPORATE_BONDS_DYNAMIC')

/**
 * Builds a graphql query filter string.
 *
 * @param activeEtfFilter - an array of active filter definitions (as defined by the backend)
 * @param etfStrategyId - an uppercase string of the strategy id
 * @returns {String} - the generated filter string
 */
function buildEtfFilter(activeEtfFilter, etfStrategyId) {
  if (!activeEtfFilter || !etfStrategyId) {
    throw new Error("IllegalArgumentException at buildEtfFilter, both activeEtfFilter and etfStrategyId params must be set")
  }

  let gqlFilterQuery = {}
  let filterCriteria = {and: []}
  let instrument = {and: []}

  activeEtfFilter.forEach(f => {
    const fItem = f.filterItem
    let or = []

    f.values.forEach(v => {
      or.push({[fItem]: {eq: v.id}})
    })

    if (fItem.startsWith('fin_')) {
      filterCriteria.and.push({or})
    } else {
      instrument.and.push({or})
    }
  })

  if (filterCriteria.and.length > 0) {
    gqlFilterQuery.filterCriteria = filterCriteria
  }
  if (instrument.and.length > 0) {
    gqlFilterQuery.instrument = instrument
  }

  gqlFilterQuery.strategyId = {eq: etfStrategyId}

  return gqlFilterQuery
}

const etfFilterBuilder = {
  buildEtfFilter
}

export default etfFilterBuilder
